import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_purples/artifacts/0x3gbqfe_Final%20Logo%20White%20%281%29.png";

export const Footer = ({ settings }) => (
  <footer data-testid="footer" className="panel-light border-t border-white/20 relative z-10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 lg:py-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 lg:gap-16">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-5">
            <img
              src={LOGO_URL}
              alt="RROV"
              className="h-10 w-auto"
              style={{ filter: 'invert(1)' }}
            />
            <span className="font-syne text-sm font-medium tracking-[0.2em] text-[#A04D1F]">GOA</span>
          </div>
          <p className="text-[#2D1810]/60 text-sm leading-relaxed max-w-xs">
            An exclusive beach club experience where world-class music meets the shores of Goa.
          </p>
        </div>

        <div>
          <p className="text-[11px] font-medium tracking-[0.15em] text-[#2D1810]/40 uppercase mb-5">Navigate</p>
          <div className="space-y-3">
            {["Events", "VIP", "Gallery", "Contact"].map((item) => (
              <Link key={item} to={`/${item.toLowerCase()}`} className="block text-sm text-[#2D1810]/70 hover:text-[#2D1810] transition-colors">
                {item}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="text-[11px] font-medium tracking-[0.15em] text-[#2D1810]/40 uppercase mb-5">Connect</p>
          {settings?.instagram_url && (
            <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-[#2D1810]/70 hover:text-[#2D1810] transition-colors">
              <Instagram size={16} /> Instagram
            </a>
          )}
        </div>
      </div>

      <div className="border-t border-[#2D1810]/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#2D1810]/40">
        <p>&copy; {new Date().getFullYear()} RROV Goa</p>
        <p>21+ Only &middot; Dress Code Applies</p>
      </div>
    </div>
  </footer>
);
